import { render } from "./urlInspection.vue?vue&type=template&id=0af9ff1d"
import script from "./urlInspection.vue?vue&type=script&lang=js"
export * from "./urlInspection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__